import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

const DatabaseKeyPage = () => {
  const [dbKey, setDbKey] = useState("");
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (!dbKey) {
      alert("Please select a database key!");
      return;
    }

    console.log("dbKey :" + dbKey);
    sessionStorage.setItem("databaseKey", dbKey);
    navigate("/login");
  };

  const options = ["spflerp2025"];

  return (
    <div className="lp-wrapper">
      <header className="lp-header">
        <div className="lp-header-mark" aria-hidden="true">
          <img src="/Assets/CompanyLogo.png" alt="" className="lp-header-logo" />
        </div>
        <div className="lp-header-title">Sivanandha Pipe Fittings Ltd</div>
      </header>

      <main className="lp-main">
        <section className="lp-card db-card">
          <div className="lp-card-header">Database Key</div>

          <div className="lp-card-body">
            <div className="lp-icon-col" aria-hidden="true">
              <img
                src="/Assets/login.png"
                alt=""
                className="lp-login-illustration db-illustration"
              />
            </div>

            <div className="lp-form-col">
              <div className="db-title">Bill Of Entry-Maintenance</div>
              <div className="db-subtitle">Select your database key to continue</div>

              <div className="lp-field">
                <label htmlFor="database-key">Database Key</label>
                <select
                  id="database-key"
                  value={dbKey}
                  onChange={(e) => setDbKey(e.target.value)}
                  className="db-select"
                >
                  <option value="">-- Select Key --</option>
                  {options.map((key) => (
                    <option key={key} value={key}>
                      {key}
                    </option>
                  ))}
                </select>
              </div>

              <div className="db-actions">
                <button type="button" onClick={handleSubmit} className="lp-login-btn db-submit-btn">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default DatabaseKeyPage;
